
export const SampleBadgeDeleted= () => {
    return (
        <span className="badge li-bg-black ml-2 li-fg-white">DELETED</span>
    );
};